module.exports = __webpack_public_path__ + "static/media/cs2.636f4491.jpg";